import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons'

export function ScrollTop() {
  return (
      <div id="od_scrolltop" className="scrolltop">
          <FontAwesomeIcon className="text-white" icon={faArrowUp}/>
      </div>
  );
}
